import React, { useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { therapists as therapistOptions } from "./AdminScheduling";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";

export default function AdminRegisterUser() {
  const [userType, setUserType] = useState("Client");
  const therapists = therapistOptions;
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", therapistId: "" });
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const update = (key) => (event) => setForm((current) => ({ ...current, [key]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    setLoading(true); setMessage(null);
    try {
      const { data } = await axiosInstance.post("/api/admin/register-user", {
        ...form, userType, assignedTherapist: userType === "Client" ? form.therapistId : "",
      });
      setMessage({ type: "success", text: data.message || "User registered successfully." });
      setForm({ firstName: "", lastName: "", email: "", therapistId: "" });
    } catch (error) {
      setMessage({ type: "error", text: error.response?.data?.message || "Unable to register user." });
    } finally { setLoading(false); }
  };

  return <div className="min-h-screen w-screen" style={{ background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)" }}><Navbar /><main className="mx-auto max-w-4xl px-4 pt-28 pb-10"><Link to="/admin" className="text-blue-600 hover:underline">Back to admin</Link><section className="mt-6 rounded-xl border border-gray-200 bg-white p-6 shadow-lg">
    <h3 className="text-xl font-semibold text-gray-800">Register User</h3>
    <form onSubmit={submit} className="mt-4 grid gap-4 md:grid-cols-2">
      <label>User type<select value={userType} onChange={(e) => setUserType(e.target.value)} className="mt-1 w-full rounded border p-2"><option>Client</option><option>Therapist</option></select></label>
      <label>First name<input required value={form.firstName} onChange={update("firstName")} className="mt-1 w-full rounded border p-2" /></label>
      <label>Last name<input required value={form.lastName} onChange={update("lastName")} className="mt-1 w-full rounded border p-2" /></label>
      <label>Email<input required type="email" value={form.email} onChange={update("email")} className="mt-1 w-full rounded border p-2" /></label>
      {userType === "Client" && <label>Assigned therapist<select required value={form.therapistId} onChange={update("therapistId")} className="mt-1 w-full rounded border p-2"><option value="">Select therapist</option>{therapists.map((therapist) => <option key={therapist.email} value={therapist.email}>{therapist.name} ({therapist.email})</option>)}</select></label>}
      {message && <p role={message.type === "error" ? "alert" : "status"} className={`md:col-span-2 ${message.type === "error" ? "text-red-700" : "text-green-700"}`}>{message.text}</p>}
      <button disabled={loading} className="rounded bg-blue-600 p-2 font-medium text-white disabled:opacity-50 md:col-span-2">{loading ? "Registering…" : "Register User"}</button>
    </form>
  </section></main></div>;
}
